import { ReactNode } from 'react';

import { useSuspenseGetStateByStateKey } from '../../../../api/lending/lapiHooks.suspense';
import { getApplicant } from '../../../../utils/getApplicant';

const capitalize = (name: string): string => {
  if (!name) return '';
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

export const WelcomeMessageSkeleton = () => (
  <div className="mb-xl h-[42px] w-[280px] animate-pulse rounded-xs bg-structure-95" />
);

export const WelcomeErrorFallback = () => {
  return <WelcomeStructure>Welcome,</WelcomeStructure>;
};

const WelcomeStructure = ({ children }: { children: ReactNode }) => {
  return <h1 className="m-0 mb-xl text-[35px] font-med">{children}</h1>;
};

export const WelcomeMessage = () => {
  const { state } = useSuspenseGetStateByStateKey();
  const applicant = getApplicant(state?.application?.people);
  const firstName = applicant?.first_name || '';

  return <WelcomeStructure>Welcome {capitalize(firstName)}!</WelcomeStructure>;
};
